import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";

const Branches = () => {
  const branches = [
    {
      name: `فرع جمعية سيهات للخدمات الاجتماعية بحي المحمدية بالدمام`,
      details: [
        `مدير الفرع`,
        `عبدالمحسن حسين السلطان`,
        `نائب المدير `,
        `علي ناصر البوعيسى`,
        `هاتف 0138383855`,
      ],
    },
    {
      name: `فرع جمعية سيهات للخدمات الاجتماعية بعنك `,
      details: [`مدير الفرع`, `محمد سعود العيد`, `هاتف 0503400850`],
    },
  ];

  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            الفروع
          </h1>
          <ul className="mt-4 md:mt-8">
            {branches.map((branch) => {
              const { name, details } = branch;
              return (
                <>
                  <li className="text-[#408099] list-disc mr-8">{name}</li>
                  <ul className="mb-4 md:mb-6">
                    {details.map((detail) => (
                      <li>{detail}</li>
                    ))}
                  </ul>
                </>
              );
            })}
          </ul>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default Branches;
